import { getOwnerId } from "../../../core/game/common/ReplicatedData";
import { useReplicatedObjectEvent } from "../../../core/game/common/ReplicatedObjectView";
import { useClue, useClueCreatedEvent } from "../../../game/contact3d/replicatedObjects/Clue";
import { useContact3DPlayerRecords } from "../../../game/contact3d/replicatedObjects/Contact3DPlayerRecords";
import { useGameState } from "../../../game/contact3d/replicatedObjects/GameState";
import { Contact3DBannerState } from "../components/Contact3DBanner";
export const useContact3DBannerEvents = (setBannerStateData) => {
    const gameState = useGameState();
    const clue = useClue();
    const players = useContact3DPlayerRecords();
    const debug = useDebug();
    // Show announcement banner when secret word created or new letter of secret word revealed.
    useReplicatedObjectEvent(gameState.secretWordContentChangedEvent, () => {
        if (gameState.secretWord !== undefined) {
            setBannerStateData({
                state: Contact3DBannerState.Announce,
                data: {
                    newLetterCurrentLetters: gameState.currentSecretWordLetters,
                }
            });
        }
    });
    // Show announcement banner when new clue created.
    useReplicatedObjectEvent(useClueCreatedEvent(), () => {
        debug.log('ClueCreatedEvent triggered');
        if (gameState.secretWord === undefined) {
            return;
        }
        setBannerStateData({
            state: Contact3DBannerState.Announce,
            data: {
                newClueText: clue.hints[0],
                newCluePlayer: players.getPlayerUsername(getOwnerId(clue))
            },
        });
    });
    // Show contact banner when clue is guessed.
    useReplicatedObjectEvent(clue === null || clue === void 0 ? void 0 : clue.clueContactEvent, () => {
        setBannerStateData({
            state: Contact3DBannerState.Contact,
            contactDuration: gameState.currentContactTime * 1000,
            cluePlayer: players.getPlayerUsername(getOwnerId(clue)),
            answerPlayer: clue.submittedAnswer.sourceUsername,
            clueSecret: clue.clueAnswer,
            submittedAnswer: clue.submittedAnswer.answer,
            secretWord: gameState.secretWord,
            isPenultimateLetter: gameState.isOnPenultimateLetter,
        });
    });
    // Show denied banner when clue is denied.
    useReplicatedObjectEvent(clue === null || clue === void 0 ? void 0 : clue.clueDeniedEvent, () => {
        const isContactActive = clue.submittedAnswer !== undefined;
        const deniedData = clue.denied;
        if (isContactActive) {
            setBannerStateData({
                state: Contact3DBannerState.Denied,
                secretWord: gameState.secretWord,
                secretWordPlayer: deniedData.secretWordGiverUsername,
                secretWordPlayerAnswer: deniedData.secretWordGiverAnswer,
                cluePlayer: players.getPlayerUsername(getOwnerId(clue)),
                clueSecret: clue.clueAnswer,
            });
        }
        else {
            setBannerStateData({
                state: Contact3DBannerState.Announce,
                data: {
                    secretWord: gameState.secretWord,
                    denyAnswer: deniedData.secretWordGiverAnswer,
                    denyPlayer: deniedData.secretWordGiverUsername,
                    cluePlayer: players.getPlayerUsername(getOwnerId(clue)),
                    clueSecret: clue.clueAnswer,
                }
            });
        }
    });
};
//# sourceMappingURL=UseContact3DBannerEvents.js.map